/*
 *
 * ----------------------------------------------- */
jQuery(function ($) {
  var headerHight = 200;

  $('a[href^="#"]')
    .not(".no-smooth-scroll, [data-toggle='tab']")
    .on("click", function () {
      var href = $(this).attr("href");
      var target = $(href === "#" || href === "" ? "html" : href);
      var position = target.offset().top - headerHight;

      $("html, body").animate(
        {
          scrollTop: position,
        },
        550,
        "swing"
      );

      return false;
    });
});

/*
 *
 * ----------------------------------------------- */
jQuery(window).scroll(function () {
  if ($(window).scrollTop() > 500) {
    $("header, .campaign_head").addClass("fixedheader");
  } else {
    $("header, .campaign_head").removeClass("fixedheader");
  }
});

/*
 *
 * ----------------------------------------------- */
jQuery(function ($) {
  $(".drawer").drawer();
});

/*
 *
 * ----------------------------------------------- */
jQuery(function ($) {
  $(".acd_list dl dt").on("click", function () {
    $(this).next().slideToggle();
    $(this).toggleClass("open");
  });
});
